import { SessionIdentity } from "@webcore/models/coreModels";

type SessionMessageType = 'SESSION_CHANGED';

interface SessionMessage {
  type: SessionMessageType;
  senderSessionIdentity: SessionIdentity | null;
}

type SessionMessageHandler = (message: SessionMessage) => void;

const CHANNEL_NAME = 'datafabriq-session';

let channel: BroadcastChannel | null = null;
const handlers = new Set<SessionMessageHandler>();

// Prevents cascade: when a tab reacts to a received message (e.g. logs out),
// the resulting Redux state change should not broadcast back to other tabs.
let isProcessingRemoteMessage = false;

function getChannel(): BroadcastChannel {
  if (!channel) {
    channel = new BroadcastChannel(CHANNEL_NAME);
    channel.onmessage = (event: MessageEvent<SessionMessage>) => {
      isProcessingRemoteMessage = true;
      try {
        for (const handler of handlers) {
          handler(event.data);
        }
      }
      finally {
        isProcessingRemoteMessage = false;
      }
    };
  }
  return channel;
}

export function broadcast(type: SessionMessageType, senderSessionIdentity: SessionIdentity | null): void {
  if (isProcessingRemoteMessage) {
    return;
  }
  const message: SessionMessage = { type, senderSessionIdentity };
  getChannel().postMessage(message);
}

export function subscribe(handler: SessionMessageHandler): () => void {
  handlers.add(handler);
  getChannel(); // ensure channel is initialized
  return () => {
    handlers.delete(handler);
  };
}

export function close(): void {
  if (channel) {
    channel.close();
    channel = null;
  }
  handlers.clear();
}
